import { useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { useColorScheme } from '@mui/material/styles';
import { ArcElement, Chart as ChartJS } from 'chart.js';
import { sum } from 'ramda';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement);

export const HalfDoughnutChartTemplate = ({ id, data }) => {
	const chartRef = useRef(null);

	const { mode: theme } = useColorScheme();

	const { values = [], backgroundColor, sumCount = 0 } = data;

	const graphData = useMemo(() => {
		if (sumCount > 0) {
			// used when we receive some actual data, not zeros
			return {
				datasets: [
					{
						data: values,
						backgroundColor,
						borderRadius: 10,
						borderWidth: 3,
						borderColor: '#F5F5F5',
					},
				],
			};
		} else {
			return {
				// used when we receive zeros
				// just placeholder data, to create "disabled" feel > graph with one full value and ligthGrey color
				datasets: [
					{
						data: [100],
						backgroundColor: ['lightGrey'],
						borderRadius: 10,
						borderWidth: 3,
						borderColor: '#F5F5F5',
					},
				],
			};
		}
	}, [values, sumCount, backgroundColor]);

	const graphPlugins = useMemo(
		() => [
			{
				id,
				beforeDraw(chart) {
					const chartData = chart?.data?.datasets[0]?.data;
					const { width } = chart;
					const { height } = chart;
					const { ctx } = chart;
					ctx.restore();

					ctx.font = `${height / 80}em sans-serif`;
					ctx.font = `${(height / 4).toFixed(2)}px sans-serif`;
					ctx.textAlign = 'center';
					ctx.fillStyle = theme === 'light' ? 'black' : 'white';
					const sumValue = chartData.length === values.length ? sum(chartData) : 0;
					ctx.fillText(sumValue, width / 2, height / 2 + 25);
					ctx.restore();

					ctx.font = `${height / 160}em sans-serif`;
					ctx.textAlign = 'center';
					ctx.fillText(id, width / 2, height / 2 + 45);
					ctx.save();
				},
			},
		],
		[id, values.length, theme],
	);

	const options = {
		rotation: -90,
		circumference: 180,
		cutout: '90%',
		maintainAspectRatio: false,
		plugins: {
			tooltip: {
				enabled: false,
			},
		},
	};

	return <Doughnut ref={chartRef} data={graphData} options={options} plugins={graphPlugins} redraw />;
};

HalfDoughnutChartTemplate.propTypes = {
	data: PropTypes.shape({
		backgroundColor: PropTypes.array,
		values: PropTypes.array,
		sumCount: PropTypes.number,
	}),
	id: PropTypes.string,
};

export default HalfDoughnutChartTemplate;
